// src/components/device-components/DeviceTypeList.jsx
import React, { useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import CustomDataGridPro from "../CustomDataGridPro";

const DeviceTypeList = ({ deviceTypes, onEdit, onDelete }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const rows = Array.isArray(deviceTypes) ? [...deviceTypes] : [];

  const columns = useMemo(
    () => [
      {
        field: "id",
        headerName: "ID",
        flex: 0.6,
        minWidth: 100,
      },
      {
        field: "type_name",
        headerName: "Type Name",
        flex: 1.2,
        minWidth: 180,
      },
      {
        field: "manufacture",
        headerName: "Manufacture",
        flex: 1,
        minWidth: 160,
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 160, // fixed so buttons don't stretch
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: ({ row }) => (
          <Box>
            <IconButton
              sx={{
                color: "#22C55E",
                mr: 1,
                "&:hover": { backgroundColor: "#BBF7D0" },
              }}
              onClick={() => onEdit(row)}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              sx={{
                backgroundColor: "#F3F4F6",
                color: "#6B7280",
                "&:hover": { backgroundColor: "#E5E7EB" },
              }}
              onClick={() => onDelete(String(row.id))}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ),
      },
    ],
    [onEdit, onDelete]
  );

  return (
    <CustomDataGridPro
      rows={rows}
      columns={columns}
      getRowId={(row) => row.id}
      page={page}
      setPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      totalCount={rows.length}
    />
  );
};

DeviceTypeList.propTypes = {
  deviceTypes: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

DeviceTypeList.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};

export default DeviceTypeList;
